import { useErrorHandler } from './useErrorHandler'

export default useErrorHandler
